import React from "react";

export const DefaultContextBadge: React.FC<{ context: "team" | "project" }> = ({ context }) => (
  <span
    title={`Default ${context}`}
    style={{
      display: "inline-flex",
      alignItems: "center",
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 12,
      fontWeight: 700,
      color: "var(--kendo-primary-130, #8f0419)",
      background: "#fff5f7",
      border: "1px solid var(--kendo-primary-10, #f1a2b3)",
      whiteSpace: "nowrap",
    }}
  >
    Default
  </span>
);
